import { useState } from 'react';
import { useGetDealerApprovalInboxQuery } from '../../../../api/endpoints/dealerApproval';
import { useLanguage } from '../../../../contexts/LanguageContext';

const useDealerApprovalInbox = () => {
    const { getCurrentLanguageId } = useLanguage();
    const LanguageId = getCurrentLanguageId();

    const [pagination, setPagination] = useState({ first: 0, rows: 10, page: 1 });

    const { data, isLoading, isFetching, refetch } = useGetDealerApprovalInboxQuery({
        PageNumber: pagination.page,
        PageSize: pagination.rows,
        LanguageId
    });

    const onPageChange = (event) => {
        setPagination({ first: event.first, rows: event.rows, page: (event.page ?? 0) + 1 });
    };

    return {
        items: data?.items || [],
        totalCount: data?.totalCount || 0,
        loading: isLoading || isFetching,
        pagination,
        onPageChange,
        refetch
    };
};

export default useDealerApprovalInbox;
